export const handleChangePage = (_event, newPage, setPage) => {
    setPage(newPage);
};

export const handleChangeRowsPerPage = (event, setRowsPerPage, setPage) => {
    const radix = 10;
    const numValue = parseInt(event.target.value, radix);

    setRowsPerPage(numValue);
    setPage(0);
};